{
  "name": "ahc-web",
  "version": "0.0.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build && rm -rf www && cp -r dist/ahc-web/browser www",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org it-pl --project javascript-angular ./dist && sentry-cli sourcemaps upload --org it-pl --project javascript-angular ./dist"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.6",
    "@angular/cdk": "^20.2.11",
    "@angular/common": "^20.3.0",
    "@angular/compiler": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@angular/forms": "^20.3.0",
    "@angular/material": "^20.2.11",
    "@angular/platform-browser": "^20.3.0",
    "@angular/router": "^20.3.0",
    "@auth0/auth0-angular": "^2.3.0",
    "@lucide/angular": "^1.17.0",
    "@sentry/angular": "10.25.0",
    "@sentry/cli": "^2.58.1",
    "@stripe/stripe-js": "^8.6.3",
    "@tailwindcss/postcss": "^4.1.14",
    "decimal.js": "^10.6.0",
    "flagsmith": "^10.0.0",
    "libphonenumber-js": "^1.12.25",
    "ngx-owl-carousel-o": "^20.0.1",
    "postcss": "^8.5.6",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.1.14",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.6",
    "@angular/cli": "^20.3.6",
    "@angular/compiler-cli": "^20.3.0",
    "@types/jasmine": "~5.1.0",
    "angular-eslint": "20.4.0",
    "eslint": "^9.37.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.6.2",
    "prettier-eslint": "^16.4.2",
    "typescript": "~5.9.2",
    "typescript-eslint": "8.46.0"
  }
}